import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 16v-8","key":"svg-0"}],["path",{"d":"M12 20a4 4 0 0 0 4 -4v-8a4 4 0 1 0 -8 0v8a4 4 0 0 0 4 4","key":"svg-1"}]]

/**
 * IconNumber0
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbnVtYmVyLTAiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE2IDE2di04IiAvPgogIDxwYXRoIGQ9Ik0xMiAyMGE0IDQgMCAwIDAgNCAtNHYtOGE0IDQgMCAxIDAgLTggMHY4YTQgNCAwIDAgMCA0IDQiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/number-0
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconNumber0 = createReactComponent('outline', 'number-0', 'Number0', __iconNode);

export default IconNumber0;